import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { SITE_DEFAULT_TITLE, buildPageTitle } from '../constants/site-meta';

@Injectable()
export class CareerGradTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const routeTitle = this.buildTitle(snapshot);
    this.title.setTitle(routeTitle ? buildPageTitle(routeTitle) : SITE_DEFAULT_TITLE);
  }
}
